<template>
  <div class="formcell">
    <div v-if="labelText" class="label">
      <slot>
        {{ labelText }}
      </slot>
      <span v-if="required" class="required">*</span>
    </div>
    <v-autocomplete
      :value="value"
      outlined
      dense
      height="48"
      :item-value="itemValue"
      :item-text="itemText"
      :hide-details="hideDetails"
      :menu-props="{ offsetY: true }"
      class="vuetify-select"
      :items="items"
      @input="(e) => $emit('input', e)"
    >
      <template #append>
        <div>
          <SearchIcon />
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
  import { VAutocomplete } from 'vuetify/lib';
  import SearchIcon from '@/assets/icons/search.svg';

  export default {
    name: 'Autocomplete',
    components: {
      VAutocomplete,
      SearchIcon,
    },
    model: {
      prop: 'value',
      event: 'input',
    },
    props: {
      labelText: {
        type: String,
        default: '',
      },
      /**
       * Is select required?
       */
      required: {
        type: Boolean,
        default: false,
      },
      hideDetails: {
        type: Boolean,
        default: true,
      },
      /**
       * Example:
       * [{
       *   value: 'en',
       *   text: 'English'
       * }]
       */
      items: {
        type: Array,
        default: () => [],
      },
      /**
       * Selected value
       */
      value: {
        type: [String, Object],
        default: '',
      },
      /**
       * Value key
       */
      itemValue: {
        type: String,
        default: 'value',
      },
      /**
       * Text key
       */
      itemText: {
        type: String,
        default: 'text',
      },
    },
  };
</script>
